import api from '../api'

export default {
    namespaced: true,
    actions: {
        getBringInfo(store, params) {
            return api.post('/data/manage/select/club', '带入信息', params)
        },
        getBringIp(store, params) {
            return api.post('/data/manage/takein/ip', '带入IP', params)
        },
        getUserGps(store, params) {
            return api.post('/data/manage/user/gps', '查询玩家GPS', params)
        },
        getUserRelevance(store, params) {
            return api.post('/data/manage/user/relevance', '查询玩家关联账户', params)
        },
        getUserRelevanceTotal(store, params) {
            return api.post('/data/manage/user/relevance/total', '查询关联总数', params)
        },
    }
}